import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=6e85b3ae&"
import script from "./ClassList.vue?vue&type=script&lang=js&"
export * from "./ClassList.vue?vue&type=script&lang=js&"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=6e85b3ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports